import { BaseParser, IValidateParams } from './BaseParser';
import { ParseResult, IParseResult } from '../FormatterTypes';
import { formatterBoolParamDef } from '../Utils/ParamUtils';
import { isLetter } from '../../../Utils/Formatters/Utils/StringUtils';

const numbers = '0123456789';

class TEDParsePostNr extends BaseParser {
  public static getInstance(): TEDParsePostNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParsePostNr;

  defaultParams(): string {
    return 'AllowForeign="Y"';
  }

  validateOveride(params: string): boolean {
    return formatterBoolParamDef('AllowForeign', params, this.defaultParams());
  }

  getValidateParams(params: string): IValidateParams {
    const inputAllowed = (key: string) => {
      return numbers.includes(key) || isLetter(key);
    };
    return { inputValid: inputAllowed, inputsList: '', separators: ' -' };
  }

  parse(text: string, params: string = ''): IParseResult {
    const postnr = text.trim();
    if (postnr !== '') {
      const allowForeign = formatterBoolParamDef(
        'AllowForeign',
        params,
        this.defaultParams()
      );
      const match = /^(SE-|S-){0,1}(([0123456789][ ]*){5})$/.exec(postnr);
      if (match && match[0] && match[2]) {
        return { result: ParseResult.OK, value: match[2].replace(/\s/g, '') };
      } else if (allowForeign) {
        return { result: ParseResult.OK, value: postnr };
      }

      return { result: ParseResult.ERROR, value: null };
    }

    return { result: ParseResult.OK, value: postnr };
  }
}

export { TEDParsePostNr };
